import React, {useEffect, useState} from 'react';
import {SaveOutlined} from "@ant-design/icons";
import axios from "axios";
import {header} from "../../../../../../../components/api/Header";
import $ from 'jquery'
import { getEnv } from "../../../../../../../lib/env";

function Maydon() {
    const [types, setTypes] = useState([])
    const season = localStorage.getItem('sfr-hm-season')
    const cropids = JSON.parse(localStorage.getItem('sfr-hm-'+season+'-ekinids'))
    const [istemolchi, setIstemolchi] = useState(localStorage.getItem('sfr-hm-istemolchilar') ? JSON.parse(localStorage.getItem('sfr-hm-istemolchilar')) : [])
    useEffect(() => {
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL') + "/v1/district/sfrmain/ekintypes?crops=" + cropids,header())
                .catch(e => {
                    console.log("Xato", e)
                })
            if (res) {
                setTypes(res.data)
            }
        }
        fetchData()
    }, [])
    const makeNol = () => {
        let nim = {}
        istemolchi.map(i => {
            let k = {}
            i.gms.map(g => {
                let e = {}
                cropids.map(c => {
                    e['e' + c] = 0
                })
                k['g' + g] = e
            })
            nim['i' + i.id] = k
        })
        return nim
    }
    const [maydon, setMaydon] = useState(localStorage.getItem('sfr-hm-'+season+'-maydon') ? JSON.parse(localStorage.getItem('sfr-hm-'+season+'-maydon')) : makeNol())
    const setMaydonhandler = (isid, g, eid, v) => {
        let nm = {...maydon}
        if (nm['i' + isid]) {
            if (nm['i' + isid]['g' + g]) {
                nm["i" + isid]['g' + g]['e' + eid] = v
            } else {
                nm["i" + isid]['g' + g] = {['e' + eid]: v}
            }
        } else {
            nm["i" + isid] = {['g' + g]: {['e' + eid]: v}}
        }

        setMaydon(nm)
    }
    return (
        <div className="row">
            <div className="col-12">
                <h3 className="text-center mt-1">Ekin maydonlari</h3>
            </div>
            <div className="col-12">
                <div className="text-end pe-2">gektar</div>
                <div className="flextable" style={{width:"max-content",maxWidth:"100%"}}>
                    <table className="table table-bordered" style={{width: "unset"}}>
                        {
                            season == 'veg' ?
                                <thead className="sticky-top" style={{background: "#77adba", color: "#fff"}}>
                                <tr>
                                    <th className="text-center vertical-middle" rowSpan="3" style={{width:"200px"}}>Manbalar</th>
                                    <th className="text-center vertical-middle" rowSpan="3">Suv istemolchilari</th>
                                    <th className="text-center vertical-middle" rowSpan="3">Gidromodul</th>
                                    <th colSpan={cropids.length} className="text-center">Qishloq xo'jaligi ekin
                                        maydoni
                                    </th>
                                </tr>
                                <tr>
                                    {
                                        types.length ?
                                            types.map((t, i) => {
                                                return <th
                                                    className="text-center vertical-middle"
                                                    rowSpan={t.grouped?1:2}
                                                    key={i}
                                                    colSpan={t.ekin.length}>
                                                    {
                                                        t.name
                                                    }
                                                </th>
                                            })
                                            : null
                                    }
                                </tr>
                                <tr>
                                    {
                                        types.length ?
                                            types.map((t, i) => {
                                                return t.ekin.map((e, i) => {
                                                    return t.grouped ? <th className="text-center vertical-middle" width="100px"
                                                                                 key={i}>{e.name}</th> : null
                                                })
                                            })
                                            : null
                                    }
                                </tr>
                                </thead>
                                :
                                <thead className="sticky-top" style={{background: "#77adba", color: "#fff"}}>
                                <tr>
                                    <th className="text-center vertical-middle" rowSpan="2">Manbalar</th>
                                    <th className="text-center vertical-middle" rowSpan="2">Suv istemolchilari</th>
                                    <th className="text-center vertical-middle" rowSpan="2">Gidromodul</th>
                                    {
                                        types.length ?
                                            types.map((t, i) => {
                                                return <th
                                                    rowSpan={t.grouped?1:2}
                                                    className="text-center vertical-middle"
                                                    key={i}
                                                    colSpan={t.ekin.length}
                                                >{t.name}</th>
                                            })
                                            : null
                                    }
                                </tr>
                                <tr>
                                    {
                                        types.length ?
                                            types.map((t, i) => {
                                                return t.ekin.map((e, i) => {
                                                    return t.grouped ? <th className="text-center vertical-middle" width="100px"
                                                                                 key={i}>{e.name}</th> : null
                                                })
                                            })
                                            : null
                                    }
                                </tr>
                                </thead>
                        }
                        <tbody>
                        {
                            istemolchi.length ?
                                istemolchi.map((ist, i) => {
                                    return ist.gms.length ?
                                        ist.gms.map((g, index) => {
                                            return <tr key={index}>
                                                <td style={{
                                                    width: "max-content",
                                                    whiteSpace: "nowrap"
                                                }}>{ist.mname}</td>
                                                <td style={{width: "max-content", whiteSpace: "nowrap"}}>{ist.name}</td>
                                                <td style={{width: "max-content", whiteSpace: "nowrap"}}>{g}</td>
                                                {
                                                    cropids.length ?
                                                        cropids.map((c) => {

                                                            return <td key={c} className="inptd">
                                                                <input
                                                                    key={c}
                                                                    type="number"
                                                                    className="inputable no-arrow text-center"
                                                                    onChange={e => setMaydonhandler(ist.id, g, c, e.target.value)}
                                                                    value={
                                                                        maydon ?
                                                                            maydon['i' + ist.id] ?
                                                                                maydon['i' + ist.id]['g' + g] ?
                                                                                    maydon['i' + ist.id]['g' + g]['e' + c] != 'undefined' ?
                                                                                        maydon['i' + ist.id]['g' + g]['e' + c]>=0?
                                                                                        maydon['i' + ist.id]['g' + g]['e' + c]
                                                                                            :''
                                                                                        : ''
                                                                                    : ''
                                                                                : ''
                                                                            : ''
                                                                    }/>
                                                            </td>
                                                        })
                                                        : null
                                                }
                                            </tr>
                                        })
                                        : null
                                })
                                : null
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="col-12 text-end mt-3 mb-1">
                <button className="btn btn-outline-success btn-sm d-flex align-items-center" onClick={() => {
                    localStorage.setItem("sfr-hm-"+season+"-maydon", JSON.stringify(maydon))
                    window.location.href = '/sfr/gidromodul/new/insert/maydon'
                }}>
                    <SaveOutlined/>&nbsp;&nbsp;Saqlash
                </button>
            </div>
        </div>
    );
}

export default Maydon;
